<template>
  <!-- 「요금·결제」의 상태 배지 하나 — 색 이름(tone)은 `utils/subscriptionAdmin` 의 판정이 준다 -->
  <span class="subscription-badge" :class="[`subscription-badge--${tone}`, { 'subscription-badge--outline': outline }]"
    ><slot></slot
  ></span>
</template>

<script>
export default {
  name: 'SubscriptionBadge',

  props: {
    /** idle · info · success · warning · danger */
    tone: { type: String, default: 'idle' },
    /** 덧붙인 표지(해지·결제 거절 …)는 테두리만 */
    outline: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
.subscription-badge {
  display: inline-block;
  padding: 1px 8px;
  border: 1px solid transparent;
  border-radius: var(--radius-sm);
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  white-space: nowrap;
}

.subscription-badge--idle {
  background: var(--color-border-light);
  color: var(--color-text-secondary);
}

.subscription-badge--info {
  background: var(--color-info-light);
  color: var(--color-info);
}

.subscription-badge--success {
  background: var(--color-success-light);
  color: #389e0d;
}

.subscription-badge--warning {
  background: var(--color-warning-light);
  color: #b07a00;
}

.subscription-badge--danger {
  background: var(--color-danger-light);
  color: var(--color-danger);
}

.subscription-badge--outline {
  border-color: currentColor;
  background: transparent;
}
</style>
